import { defineStore } from "pinia";
import { computed, ref } from "vue";
import { catalogReviewRepository } from "../repositories/catalog-review.repository";
const DEFAULT_PAGE_SIZE = 5;
export const useCatalogReviewStore = defineStore("catalogReview", () => {
    const items = ref([]);
    const pagination = ref(null);
    const currentServiceId = ref(null);
    const isLoading = ref(false);
    const error = ref(null);
    const hasMore = computed(() => {
        if (!pagination.value)
            return false;
        return pagination.value.page < pagination.value.total_pages;
    });
    async function fetchReviews(serviceId, limit = DEFAULT_PAGE_SIZE) {
        currentServiceId.value = serviceId;
        items.value = [];
        pagination.value = null;
        isLoading.value = true;
        error.value = null;
        try {
            const page = await catalogReviewRepository.getServiceReviews(serviceId, {
                page: 1,
                limit,
            });
            items.value = page.items;
            pagination.value = page.pagination;
        }
        catch (err) {
            error.value =
                err instanceof Error ? err.message : "Error fetching service reviews";
        }
        finally {
            isLoading.value = false;
        }
    }
    async function loadMore() {
        if (!currentServiceId.value ||
            !pagination.value ||
            !hasMore.value ||
            isLoading.value) {
            return;
        }
        isLoading.value = true;
        error.value = null;
        try {
            const page = await catalogReviewRepository.getServiceReviews(currentServiceId.value, { page: pagination.value.page + 1, limit: pagination.value.limit });
            items.value = [...items.value, ...page.items];
            pagination.value = page.pagination;
        }
        catch (err) {
            error.value =
                err instanceof Error ? err.message : "Error fetching more reviews";
        }
        finally {
            isLoading.value = false;
        }
    }
    function $reset() {
        items.value = [];
        pagination.value = null;
        currentServiceId.value = null;
        isLoading.value = false;
        error.value = null;
    }
    return {
        items,
        pagination,
        currentServiceId,
        isLoading,
        error,
        hasMore,
        fetchReviews,
        loadMore,
        $reset,
    };
});
